export const enAgentGuiProviderIdentity = {
  conversationFilterCodex: "Codex",
  conversationFilterClaudeCode: "Claude Code",
  conversationFilterOpenCode: "OpenCode",
  conversationFilterTutti: "Tutti",
  conversationFilterCursor: "Cursor",
  conversationFilterNexight: "Nexight",
  conversationFilterHermes: "Hermes Agent",
  conversationFilterOpenClaw: "OpenClaw",
  manageAgents: "Agent Sidebar Display Settings",
  manageAgentsTitle: "Agent Sidebar Display Settings",
  manageAgentsDescription:
    "Drag to reorder or move agents between the available and disabled groups. Press and hold an agent to edit.",
  manageAgentsAvailable: "Available Agents",
  manageAgentsDisabled: "Disabled Agents",
  manageAgentsNoAvailable: "Add an agent from the disabled list below.",
  manageAgentsNoDisabled:
    "Drag agents you don’t want to show in the sidebar here.",
  manageAgentsKeepOneAvailable: "Keep at least one agent available.",
  manageAgentsRunningBlocked:
    "{{agent}} is running and can't be disabled. Wait for it to finish and try again.",
  removeAgentFromSidebar: "Remove {{agent}} from sidebar",
  addAgentToSidebar: "Add {{agent}} to sidebar",
  dragAgentToReorder: "Drag {{agent}} to reorder"
} as const;
